// The assets service replies with { status, timestamp, message, path }, where
// message is either a string ("Pair not found") or a list of validation
// messages ("tradingConfig.pricePrecision must not be greater than 18").
// Note the field is "status", not "statusCode".

const DTO_PREFIX = /^(tradingConfig|data)\./;

export function getApiErrorMessages(error) {
  const response = error && error.response;
  if (!response) return ["Could not reach the server. Check your connection and try again."];
  if (response.status === 401) return ["Your session has expired. Please log in again."];

  const message = response.data && response.data.message;
  if (Array.isArray(message) && message.length) {
    return message.map((item) => String(item).replace(DTO_PREFIX, ""));
  }
  if (typeof message === "string" && message) {
    return response.status >= 500 ? [`Server error ${response.status}: ${message}`] : [message];
  }
  return [`Request failed with status ${response.status}.`];
}

export default getApiErrorMessages;
